export default class BaseMapper {
  constructor({
    entity = {},
    schema = {},
  } = {}) {
    // Immutable and non-enumerable
    Object.defineProperty(this, 'entity', {
      value: entity || {},
    });
    Object.defineProperty(this, 'schema', {
      value: schema || {},
    });

    if (Object.prototype.hasOwnProperty.call(schema, 'entity') || Object.prototype.hasOwnProperty.call(schema, 'schema')) {
      throw Error(`Keyword 'entity' or 'schema' should not be used as keys in schema`);
    }

    Object.assign(this, this.build());
  }

  build(entity = this.entity, schema = this.schema) {
    if (!entity) {
      return {};
    }

    const keys = Object.keys(schema);
    return _.zipObject(keys, keys.map((key) => {
      const schemaField = schema[key];
      const fromResponse = schemaField.fromResponse || (ent => _.get(ent, schemaField.parseFrom || key));
      return fromResponse(entity);
    }));
  }

  static prepare(entity = this.entity, schema = this.schema) {
    if (!entity) {
      return {};
    }

    return Object.keys(schema)
      .filter(key => (!schema[key].omitFromRequest))
      .reduce((result, key) => {
        const schemaField = schema[key];
        const defaultToRequest = ent => ({
          [key]: _.get(ent, key),
        });
        if (schemaField.toRequest && (!_.isFunction(schemaField.toRequest) || !_.isObject(schemaField.toRequest(entity)))) {
          throw Error(`The toRequest property for ${key} field should be a function that returns an object`);
        }
        return {
          ...result,
          ...((schemaField.toRequest || defaultToRequest)(entity)),
        };
      }, {});
  }
}
